/* eslint-disable import/no-extraneous-dependencies */
import React from 'react';
import { compose, bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { addUserMessage } from 'react-chat-widget-t';
import { v4 as uuidv4 } from 'uuid';
import './carousel.css';
import {
  Button, Card, CardActions, CardContent, Typography, CardMedia,
} from '@material-ui/core';
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';
import styles from './Carousel.module.css';

import { sendTextMessage } from '../Webwidget/actions';

function Carousel(props) {
  const carouselRef = React.createRef();
  const { items } = props;

  function scrollToItem(isScrollToNextItem) {
    const carousel = carouselRef.current;
    const carouselScroller = carousel.querySelector('.carouselScroller');
    const carouselItemSize = carouselScroller.querySelector('div').clientWidth;
    carouselScroller.scrollBy(isScrollToNextItem ? carouselItemSize : -carouselItemSize, 0);
  }

  return (
    <div className="rcw-response">
      <div className={`rcw-message-text ${styles.rcwMessageText}`} style={{ maxWidth: '315px', padding: 0 }}>
        <div id="paginated_carousel" className="carousel" ref={carouselRef}>
          <div className="carouselScroller">
            {items && items.map((item) => (
              <div
                className="colored_card"
                key={uuidv4()}
              >
                <div>
                  <Card variant="outlined" className={styles.cardContainer}>
                    {item.image && (
                      <CardMedia
                        component="img"
                        alt={item.image.placeholder}
                        height="140"
                        style={{
                          backgroundImage: `url(${item.image.url})`,
                        }}
                        image="data:image/png;base64,R0lGODlhFAAUAIAAAP///wAAACH5BAEAAAAALAAAAAAUABQAAAIRhI+py+0Po5y02ouz3rz7rxUAOw=="
                        title={item.image.placeholder}
                        className={styles.cardImage}
                      />
                    )}
                    <CardContent>
                      <Typography
                        variant="subtitle1"
                        component="h4"
                        className={styles.cardTextOverflow}
                      >
                        {`${item.title}`}
                      </Typography>
                      <Typography
                        variant="body2"
                        color="textSecondary"
                        component="p"
                        className={styles.cardTextOverflow}
                      >
                        {item.desc}
                      </Typography>
                    </CardContent>
                    <CardActions>
                      <Button variant="outlined" size="small" color="primary" fullWidth>
                        <span
                          style={{ whiteSpace: 'normal', width: '100%', textOverflow: 'ellipsis' }}
                          role="button"
                          tabIndex={0}
                          onKeyPress={() => {}}
                          onClick={() => {
                            const text = item.button ? item.button.title : item.title;
                            props.sendTextMessage(text);
                            addUserMessage(text);
                          }}
                        >
                          {item.button ? item.button.title : 'select'}
                        </span>
                      </Button>
                    </CardActions>
                  </Card>
                </div>
              </div>
            ))}
          </div>
          <span
            className="btn prev"
            role="button"
            tabIndex={0}
            onClick={() => {
              scrollToItem(false);
            }}
            onKeyPress={() => {}}
          >
            <ArrowBackIosIcon className="icon" />
          </span>
          <span
            className="btn next"
            role="button"
            tabIndex={0}
            onClick={() => {
              scrollToItem(true);
            }}
            onKeyPress={() => {}}
          >
            <ArrowForwardIosIcon className="icon" />
          </span>
        </div>
      </div>
    </div>
  );
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({ sendTextMessage }, dispatch);
}

const withConnect = connect(
  null,
  mapDispatchToProps,
);

Carousel.propTypes = {
  sendTextMessage: PropTypes.func.isRequired,
  items: PropTypes.arrayOf(
    PropTypes.shape({
      image: PropTypes.shape({
        url: PropTypes.string,
        placeholder: PropTypes.string,
      }),
      title: PropTypes.string,
      desc: PropTypes.string,
      button: PropTypes.shape({
        title: PropTypes.string.isRequired,
        url: PropTypes.string,
        response: PropTypes.string,
      }),
    }),
  ),
};

Carousel.defaultProps = {
  items: [],
};

export default compose(
  withConnect,
)(Carousel);
